import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="billing-address-form"
export default class extends Controller {
  static targets = [ "id", "firstname", "lastname", "email", "phone", "address1", "address2", "address3", "town", "county", "postcode", "addressFields", "billingAddressId", "form" , "firstnameWrapper", "lastnameWrapper", "emailWrapper", "phoneWrapper", "address1Wrapper", "address2Wrapper", "address3Wrapper", "townWrapper", "countyWrapper", "postcodeWrapper"]

  connect() {
    this.blankForm()
  }

  change(_event) {
    var value = this.billingAddressIdTarget.value
    // if value null
    if (value === '') {
      this.showForm()
    } else {
      this.hideForm()
    }
  }

  blankForm() {
    this.firstnameTarget.value = ''
    this.lastnameTarget.value = ''
    this.emailTarget.value = ''
    this.phoneTarget.value = ''
    this.address1Target.value = ''
    this.address2Target.value = ''
    this.address3Target.value = ''
    this.townTarget.value = ''
    this.countyTarget.value = ''
    this.postcodeTarget.value = ''
  }

  hideForm(){
    this.firstnameWrapperTarget.classList.add('hidden')
    this.lastnameWrapperTarget.classList.add('hidden')
    this.emailWrapperTarget.classList.add('hidden')
    this.phoneWrapperTarget.classList.add('hidden')
    this.address1WrapperTarget.classList.add('hidden')
    this.address2WrapperTarget.classList.add('hidden')
    this.address3WrapperTarget.classList.add('hidden')
    this.townWrapperTarget.classList.add('hidden')
    this.countyWrapperTarget.classList.add('hidden')
    this.postcodeWrapperTarget.classList.add('hidden')
    // this.idTarget.value = ''
    this.blankForm()
  }

  showForm() {
    this.firstnameWrapperTarget.classList.remove('hidden')
    this.lastnameWrapperTarget.classList.remove('hidden')
    this.emailWrapperTarget.classList.remove('hidden')
    this.phoneWrapperTarget.classList.remove('hidden')
    this.address1WrapperTarget.classList.remove('hidden')
    this.address2WrapperTarget.classList.remove('hidden')
    this.address3WrapperTarget.classList.remove('hidden')
    this.townWrapperTarget.classList.remove('hidden')
    this.countyWrapperTarget.classList.remove('hidden')
    this.postcodeWrapperTarget.classList.remove('hidden')
  }
}
